import { apiClient } from './client'
import type { ApiResponse, PlayAuthResponse, PlayLoginResponse } from '@/types'

export const authApi = {
  login: async (email: string, password: string, userType: string): Promise<PlayLoginResponse> => {
    const response = await apiClient.post<ApiResponse<PlayLoginResponse>>(
      '/play/auth/login',
      { email, password, userType }
    )
    return response.data.data!
  },

  selectAccount: async (selectToken: string, source: string): Promise<PlayAuthResponse> => {
    const response = await apiClient.post<ApiResponse<PlayAuthResponse>>(
      '/play/auth/select-account',
      { selectToken, source }
    )
    return response.data.data!
  },

  socialLogin: async (
    socialToken: string,
    socialType: string,
    socialCode?: string
  ): Promise<PlayAuthResponse> => {
    const response = await apiClient.post<ApiResponse<PlayAuthResponse>>(
      '/play/auth/social',
      { socialToken, socialType, socialCode }
    )
    return response.data.data!
  },

  refresh: async (refreshToken: string): Promise<PlayAuthResponse> => {
    const response = await apiClient.post<ApiResponse<PlayAuthResponse>>(
      '/play/auth/refresh',
      { refreshToken }
    )
    return response.data.data!
  },
}
